import { useQuery } from "@tanstack/react-query";
import client from "../../api/commonApi";

const fetchPlatformDetail = (coffee_key_id) => {
  return client.get(`/bean/profile/total/${coffee_key_id}`);
};

export const useSearchDetailProfileQuery = (coffee_key_id) => {
  // 테스트용
  // const coffee_key_id = '695b82cd-74a2-472a-ad44-677034cbe992';
  return useQuery({
    queryKey: ["bean-profile-detail", coffee_key_id],
    queryFn: () => fetchPlatformDetail(coffee_key_id),
    select: (result) => result.data.data,
    staleTime: 300000,
  });
};
